// ── V152: 단가표 실사용량 — 신선식품은 로스를 빼고, 공산품은 NET 중량으로 원가를 낸다 ─────────
// 사장님: "단가표 입력 시 신선식품은 로스 중량 입력, 공산품은 NET 무게 입력해서
//          실제 용량에 단가를 계산해서 산출되도록"
//   · 신선식품: net_g = 구매 중량(예: 양파 1망 5000g), loss_g = 로스(껍질·꼭지 등 500g)
//              → 실사용량 4500g. 레시피 재료 1g의 원가 = 단가 ÷ 4500
//   · 공산품: net_g = NET 중량(포장 안 내용물, 예: 간장 1.8L = 1800g) — 그대로 실사용량
//   · 소모품·반제품: net_g = 기준량 그대로
// 레시피 g → 구매 단위 환산(발주량·예상 사용량)도 실사용량으로 나눈다 (로스만큼 더 사야 하니까).
// 구매 단위 자체의 무게가 필요한 곳(V135 묶음 판단, 시장가 kg 비교)은 net_g를 그대로 쓴다.

export const FRESH_CATEGORY = '신선식품';
export const NET_CATEGORY = '공산품';

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** 로스를 적용하는 품목인지 (신선식품만) */
export const usesLoss = (p) => !!p && p.category === FRESH_CATEGORY;

/** 원가 계산에 실제로 빼는 로스(g) — 구매 중량보다 작을 때만 */
export function lossG(p) {
  if (!usesLoss(p)) return 0;
  const net = num(p.net_g);
  const loss = num(p.loss_g);
  return loss > 0 && loss < net ? loss : 0;
}

/** 실사용량(g) — 원가·발주량 계산의 기준. net_g가 없으면 0 */
export function usableG(p) {
  const net = num(p && p.net_g);
  if (net <= 0) return 0;
  return net - lossG(p);
}

/** 수율(%) — 실사용량 ÷ 구매 중량. 로스가 없으면 100 */
export function yieldPct(p) {
  const net = num(p && p.net_g);
  if (net <= 0) return 100;
  return Math.round((usableG(p) / net) * 1000) / 10;
}

/** 실사용 1kg당 단가 (없으면 0) */
export function pricePerUsableKg(p, price = p && p.price) {
  const u = usableG(p);
  const v = num(price);
  return u > 0 && v > 0 ? v / (u / 1000) : 0;
}
